var english = [// SECTION A
"ahole", "anus", "arse", "ash0le", "ash0les", "asholes", "ass", "ass monkey", "assface", "assh0le", "assh0lez", "asshole", "assholes", "assholz", "asswipe", "azzhole", // SECTION B
"blow job", "butthole", "buttwipe", "butt", // SECTION C
"c0ck", "c0cks", "c0k", "cawk", "cawks", "child-fucker", "clit", "cnts", "cntz", "cock", "cockhead", "cocks", "cocksucker", "cum", "cunt", "cunts", "cuntz", // SECTION D
"dick", "dild0", "dild0s", "dildo", "dildos", "dilld0", "dilld0s", "dominatricks", "dominatrics", "dominatrix", // SECTION E
"effing", "ejaculate", // SECTION F
"fuck", "fucker", "fart", "fuck", "fucker", "fuckin", "fucking", "fucks", "fudge packer", "fudge", "fuk", "fukah", "fuken", "fuker", "fukin", "fukk", "fukkah", "fukken", "fukker", "fukkin", // SECTION G
// SECTION H
"h00r", "h0ar", "h0re", "hoar", "hoor", "hoore", // SECTION I
// SECTION J
"jackoff", "jap", "japs", "jerk", "jism", "jiss", "jizm", "jizz", // SECTION K
"knob", "knobs", "knobz", "kunt", "kunts", "kuntz", // SECTION L
// SECTION M
"masochist", "masokist", "massterbait", "masstrbait", "masstrbate", "masterbaiter", "masterbate", "masterbates", "motha fucker", "motha fuker", "motha fukkah", "motha fukker", "mother fucker", "mother fukah", "mother fuker", "mother fukkah", "mother fukker", "mother-fucker", "mutha fucker", "mutha fukah", "mutha fuker", "mutha fukkah", "mutha fukker", // SECTION N
// SECTION O
"orafis", "orgasim", "orgasm", "orgasum", "oriface", "orifice", "orifiss", // SECTION P
"pecker", "peeenus", "peeenusss", "peenus", "peinus", "pen1s", "penas", "penis", "penis-breath", "penus", "penuus", "phuc", "phuck", "phuk", "phuker", "phukker", "poonani", "pusse", "pussee", "pussy", "puuke", "puuker", // SECTION Q
// SECTION R
"recktum", "rectum", // SECTION S
"sadist", "schlong", "screwing", "semen", "sex", "sexy", "skanck", "slag", "slut", "sluts", "slutty", "slutz", // SECTION T
"tit", // SECTION U
// SECTION V
"va1jina", "vag1na", "vagiina", "vagina", "vaj1na", "vajina", "vullva", "vulva", // SECTION W
"wh00r", "wh0re", "whore", // SECTION X
"xrated", "xxx"];

var english$1 = [// SECTION A
// SECTION B
"bassterds", "bastard", "bastards", "bastardz", "basterds", "basterdz", "biatch", "bitch", "bitches", "boffing", // SECTION C
"carpet muncher", "crap", // SECTION D
"damn", "dyke", // SECTION E
// SECTION F
"fag", "fag1t", "faget", "fagg1t", "faggit", "faggot", "fagg0t", "fagit", "fags", "fagz", "faig", "faigs", "fart", "flipping the bird", // SECTION G
"g00k", "god-damned", "goddamn", "godamn", // SECTION H
"hells", "hell", "holy shit", "horse shit", // SECTION I
// SECTION J
// SECTION K
// SECTION L
"lezzian", "lipshits", "lipshitz", // SECTION M
// SECTION N
"n1gr", "nastt", "nigger", "nigur", "niiger", "niigr", "nigga", // SECTION O
// SECTION p
"packi", "packie", "packy", "paki", "pakie", "paky", "polac", "polack", "polak", "pr1c", "pr1ck", "pr1k", // SECTION Q
"queer", "queers", "queerz", "qweers", "qweerz", "qweir", // SECTION R
"retard", // SECTION s
"scank", "sh!t", "sh1t", "sh1ter", "sh1ts", "sh1tter", "sh1tz", "shit", "shits", "shitter", "shitty", "shity", "shitz", "shyt", "shyte", "shytty", "shyty", "skanck", "skank", "skankee", "skankey", "skanks", "skanky", "son-of-a-bitch", // SECTION T
"turd", // SECTION U
// SECTION V
// SECTION W
"w0p"];

var filipino = [// SECTION A
// SECTION B
"bilat", "boto", "brocha", "burat", // SECTION C
// SECTION D
// SECTION E
"etits", // SECTION F
// SECTION G
// SECTION H
"hindot", // SECTION I
"iniyot", "iyot", // SECTION J
// SECTION K
"kantot", "kantotan", "kantut", "kantutan", "kaululan", "kiki", // SECTION L
// SECTION M
// SECTION N
"nakakaburat", // SECTION O
// SECTION P
"poke", "poki", "poyet", "pu'keng", "puke", "puki", "puking", "putaragis", "putragis", "puyet", "puwet", "pwet", // SECTION Q
// SECTION R
"ratbu", // SECTION S
"suso", "susu", // SECTION T
"tamod", "tete", "teti", "tite", "titi"];

var filipino$1 = [// SECTION A
"amputa", "animal ka", // SECTION B
"binibrocha", "bobo", "bubu", "b0b0", "brocha", "bwesit", "bwisit", "bwiset", // SECTION C
// SECTION D
"dimonyo", "demonyo", // SECTION E
"engot", // SECTION F
// SECTION G
"gaga", "gagi", "gago", // SECTION H
"habal", "hayop ka", "hayup", "hinampak", "hinayupak", "hudas", // SECTION I
"inutel", "inutil", // SECTION J
// SECTION K
"kagaguhan", "kagang", "kaululan", "kayat", "kikinginamo", "kingina", "kupal", // SECTION L
"leche", "leching", "lechugas", "lintik", // SECTION M
// SECTION N
"nimal", // SECTION O
"ogag", "olok", // SECTION P
"pakingshet", "pakshet", "pakyu", "pesteng yawa", "pokpok", "pucha", "puchanggala", "puchangina", "pukinangina", "punyeta", "puta", "putang", "putang ina", "putangina", "putanginamo", "putaragis", "putragis", // SECTION Q
// SECTION R
// SECTION S
"shunga", "sira ulo", "siraulo", // SECTION T
"tae", "taena", "tanga", "tangina", "taragis", "tarantado", "timang", "tinil", "tungaw", // SECTION U
"ulol", "ulul", "ungas", // SECTION V
"vovo", "vuvu"];

/**
 * List of all built in blacklisted words.
 */

var list = {
  english: {
    profanity: english$1,
    sexual: english
  },
  filipino: {
    profanity: filipino$1,
    sexual: filipino
  }
};

var uniqueOnly = function uniqueOnly(arr) {
  return arr.filter(function (v, i, a) {
    return a.indexOf(v) === i;
  });
};
/**
 * Returns a distinct values for all the blacklisted words given
 *
 * @param {Array<string>} args Word to be blacklisted.
 */

var blacklist = function blacklist() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return uniqueOnly(args);
};
/**
 * Filters the blacklist to allow some given words
 *
 * @param {Array<string>} blacklist Blacklisted words.
 * @param {Array<string>} args Word to be whitelisted.
 */

var whitelist = function whitelist(blacklist) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return uniqueOnly(blacklist.filter(function (b) {
    return !args.includes(b);
  }));
};
/**
 * Evaluate a string if its in the blacklist and
 * return an edited version.
 *
 * @param {string} string - Sentence to filter.
 * @param {Array<string>} blacklist Blacklisted words.
 * @param {string} grawlix Character used to replace
 * the blacklisted word.
 */

var redact = function redact(string, blacklist, options) {
  var _options$grawlix, _options$replaceByLen, _options$caseSensitiv;

  var grawlix = (_options$grawlix = options === null || options === void 0 ? void 0 : options.grawlix) !== null && _options$grawlix !== void 0 ? _options$grawlix : '*';
  var replaceByLength = (_options$replaceByLen = options === null || options === void 0 ? void 0 : options.replaceByLength) !== null && _options$replaceByLen !== void 0 ? _options$replaceByLen : true;
  var caseSensitive = (_options$caseSensitiv = options === null || options === void 0 ? void 0 : options.caseSensitive) !== null && _options$caseSensitiv !== void 0 ? _options$caseSensitiv : false;
  return string.split(" ").map(function (word) {
    var condition = caseSensitive ? blacklist.includes(word) : blacklist.includes(word.toLowerCase());

    if (condition) {
      return replaceByLength ? grawlix.repeat(word.length) : grawlix;
    }

    return word;
  }).join(" ");
};
/**
 * Returns if the sentence has a blacklisted word
 *
 * @param {string} string - Sentence to lookup.
 * @param {Array<string>} blacklist Blacklisted words.
 */

var isBlacklisted = function isBlacklisted(string, blacklist) {
  return string.split(" ").some(function (word) {
    return blacklist.includes(word.toLowerCase());
  });
};
/**
 * Returns the count of blacklisted words in the sentence
 *
 * @param {string} string - Sentence to lookup.
 * @param {Array<string>} blacklist Blacklisted words.
 */

var blacklistCount = function blacklistCount(string, blacklist) {
  return string.split(" ").filter(function (word) {
    return blacklist.includes(word.toLowerCase());
  }).length;
};

export { blacklist, blacklistCount, isBlacklisted, list, redact, whitelist };
//# sourceMappingURL=redact.esm.js.map
